import ArrowLeft from '@assets/icons/arrow-left.svg';
import DeleteIcon from '@assets/icons/delete.svg';
import React from 'react';
import { APP_MODAL_ROUTES } from '@/navigators/routes';
import { AppModalStackParams } from '@/navigators/types';
import { InvoiceDetailComponent } from './invoice-detail-component';
import { ModalContainer } from '@/components/modal-container';
import { StackScreenProps } from '@react-navigation/stack';
import { useLayoutContext } from '@/contexts/layout-context';

type Props = StackScreenProps<
  AppModalStackParams,
  APP_MODAL_ROUTES.InvoiceDetailModal
>;

export const InvoiceDetailModalScreen: React.FC<Props> = ({ route }) => {
  const { invoiceUUID, renderPayable } = route.params;
  const { isSmallLayout } = useLayoutContext();

  return isSmallLayout ? (
    <InvoiceDetailComponent
      invoiceUUID={invoiceUUID}
      navigationHeaderOverrides={{
        containerStyle: {
          paddingTop: 8,
        },
        showShadow: false,
      }}
      renderPayable={renderPayable}
    />
  ) : (
    <ModalContainer
      navigationHeaderProps={{
        BackButtonIcon: isSmallLayout ? ArrowLeft : DeleteIcon,
        showBackButton: true,
        showShadow: false,
      }}
      showLargeLayoutCloseButton={false}
    >
      <InvoiceDetailComponent
        invoiceUUID={invoiceUUID}
        renderPayable={renderPayable}
      />
    </ModalContainer>
  );
};
